import React from 'react';
import classNames from 'classnames/bind';
import styles from './FormShare.module.scss';
import { Row, Form } from 'antd';
import { SVGS } from '~/assets/assetsPath';

const cx = classNames.bind(styles);

const FormShare = ({ onAgree, onReject, title, content }) => {
    return (
        <Form>
            <Form.Item>
                <Row justify="center" className={cx('name_page')}>
                    Confirm
                </Row>
            </Form.Item>
            <Form.Item>
                <Row justify="center" className={cx('title')}>
                    <div dangerouslySetInnerHTML={{ __html: title }}></div>
                </Row>
            </Form.Item>
            <Form.Item>
                <Row justify="center" className={cx('bio')}>
                    <div dangerouslySetInnerHTML={{ __html: content }}></div>
                </Row>
            </Form.Item>
            <Form.Item style={{ marginTop: '40px' }}>
                <Row>
                    <div className={cx('btn_cancel')} onClick={onReject}>
                        Cancel
                    </div>
                    <div className={cx('btn_logout')} onClick={onAgree}>
                        Share
                    </div>
                </Row>
            </Form.Item>
        </Form>
    );
};

export default FormShare;
